<template>
  <div class="student_report_shengya">
    <div class="circle_name" style="margin-top: 30px">
      <span></span>推荐{{text}}
    </div>
     <div class="zyzytj" style="padding-bottom: 0">
       <div class="tjlist">
         <div class="tjtop">
           {{text1}}
         </div>
         <div class="tjbottoms">
           {{text2}}：{{cdata.name||cdata.oneItem}}<template v-if="cdata.twoItemValue">的工作</template>。
         </div>
       </div>
       <div class="tjlist">
         <div class="tjtop">
           {{text3}}
         </div>
         <div class="tjbottom">
           <div v-for="(item,index) in cdata.professionCode||cdata.twoItemValue" :key="index">
             <div v-if="cdata.professionCode">
               <span></span>{{item.name}}  {{item.code}}
             </div>
             <div v-if="cdata.twoItemValue">
               <span></span>{{item.two}}
             </div>
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
export default {
   props:{
     content:{
      type:Object,
    },
     number:{
      type:String
     },
     type:{
       type:String
     }
  },
  computed:{
    cdata:{
      get(){
        this.number=='0'&&(this.text='一')
        this.number=='1'&&(this.text='二')
        this.number=='2'&&(this.text='三')
        if(this.type=='1'){
          this.text1='专业类'
          this.text2='通过对您的人格特性、认知潜能、兴趣倾向的三方面综合分析，与您匹配的专业类别是'
          this.text3='具体专业及代码'
        }else{
          this.text1='职业类'
          this.text2='通过对您的的兴趣倾向、职业价值观的综合分析，你适合从事'
          this.text3='推荐职业'
        }
        return this.content
      },
      set(v){
        console.log(v)

      }


    }
  },
  data(){
    return {
      text:'',
      text1:'',
      text2:'',
      text3:''
    }
  },
  created(){
  },
  mounted() {

  },
}
</script>
<style lang="less" scoped>
    @import '../../css/evaluationReport.less';
    .circle_name{
      font-size: 14px;
      display: flex;
      align-items: center;
      line-height: 24px;
      span{
        width: 12px;
        height: 12px;
        background: #00A2FF;
        border: 2px solid #D4F0FF;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
</style>